import { useContext } from "react";
import { WindowContext } from "../providers/WindowProvider";

function useWindow() {
  var windowFromContext = useContext(WindowContext);
  return windowFromContext !== null && windowFromContext !== void 0 ? windowFromContext : typeof window === "undefined" ? null : window;
}

export default useWindow;